import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentConditionList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentCondition', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    const conditionTypeColumn = (rowData) => {
        const typeMap = {
            0: t('Normal'),
            1: t('Special'),
            2: t('Other')
        }
        return typeMap[rowData.Type] || rowData.Type || ''
    }

    return (
        <M_Table
            entityName={'EquipmentCondition'}
            api='secondary'
            showTitle={true}
            title={'Equipment Conditions'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentConditionCrud', 'Create', t('Add')+' '+t('Equipment')+' '+ t('Condition'), row)],
                ['Edit', (row) => newRoute('containerControl/equipmentConditionCrud', 'Edit', t('Edit')+' '+t('Equipment')+' '+ t('Condition'), row)],
                ['Copy', (row) => newRoute('containerControl/equipmentConditionCrud', 'Copy', t('Copy')+' '+t('Equipment')+' '+ t('Condition'), row)]
            ])}
            columnTemplates={[
                {
                    field: 'Type',
                    body: conditionTypeColumn
                }
            ]}
        />
    )
}